// Slideshow for Charm Bar Page
document.addEventListener("DOMContentLoaded", () => {
  const slideshowContainer = document.getElementById("product-slideshow");

  if (slideshowContainer) {
    console.log("Initializing slideshow on charm bar page...");

    const slides = slideshowContainer.querySelectorAll(".slide");
    let currentSlide = 0;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.style.display = i === index ? "block" : "none";
      });
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }

    // Initialize slideshow
    showSlide(currentSlide);
    setInterval(nextSlide, 2000); // Change slides every 3 seconds
  } else {
    console.log("Slideshow container not found on charm bar page.");
  }
});
